import React from "react";
import "./Banner.css";
import bannerImg from "../../../../assets/banner-1.jpg";
import { Link } from "react-router-dom";

const Banner = () => {
  return (
    <div className="mt-0 pt-0">
      <hr className="hr" />
      <div className="row banner-container mt-5">
        <div className="col-12 col-md-6 col-lg-6  ">
          <div className="banner-left banner-left-img ps-5 ms-5 ">
            <img src={bannerImg} className="img-fluid  banner-img" alt="" />
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-6 mt-5 pt-5 ">
          <div className="banner-right">
            <p className="top-sub-title mt-4 fs-5">
              Jr. Front End Developer || Jr. Web Developer
            </p>
            <h1 className="fw-bold my-4  banner-top-title "> <span className="text-secondary fs-2">I'm </span>
               Jannatul ferdous Happy
            </h1>
           
            <div className="icon ps-2  d-flex">
              <a  href="https://www.linkedin.com/in/jannatulferdoushappy/"target="_blank"rel="noreferrer" >
                <i className="fab fa-linkedin "></i>
              </a>

              <a href="https://github.com/JannatulHappy" target="_blank"rel="noreferrer" >
                <i className="fab fa-github"></i>
              </a>

              <a
               
                href="https://www.facebook.com/JannatulFerdousHappy1" target="_blank"rel="noreferrer"
              >
                <i className="fab fa-facebook-square "></i>
              </a>
            </div>
            <div>
              <a
                href="https://drive.google.com/file/d/1kyapPTsx7ljApZXsZxstBu1B6rT8vIFh/view?usp=sharing" target="_blank"rel="noreferrer"
                className="btn portfolio-btn"
              >
                Download Resume
              </a>
             
              <Link to="/contact"><button className="btn portfolio-btn">Contact Me</button></Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
